import { Select, Button } from "antd";

const selectProps = {
  allowClear: true,
  showSearch: true,
  size: "small",
  className: "w-full min-w-[140px]",
  getPopupContainer: (trigger) => trigger.parentNode,
};

export default function AttributionFilters({ filters, options, onChange, onReset }) {
  const hasActive = filters.platform || filters.account || filters.campaign;

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end">
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-500 uppercase">Source</label>
        <Select
          {...selectProps}
          placeholder="All sources"
          value={filters.platform}
          onChange={(v) => onChange({ ...filters, platform: v ?? null })}
          options={(options.platforms ?? []).map((v) => ({ label: v, value: v }))}
        />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-500 uppercase">Account</label>
        <Select
          {...selectProps}
          placeholder="All accounts"
          value={filters.account}
          onChange={(v) => onChange({ ...filters, account: v ?? null })}
          options={(options.accounts ?? []).map((v) => ({ label: v, value: v }))}
        />
      </div>
      <div className="flex flex-col gap-1 sm:min-w-[200px]">
        <label className="text-xs font-medium text-gray-500 uppercase">Campaign</label>
        <Select
          {...selectProps}
          placeholder="All campaigns"
          value={filters.campaign}
          onChange={(v) => onChange({ ...filters, campaign: v ?? null })}
          options={(options.campaigns ?? []).map((v) => ({ label: v, value: v }))}
        />
      </div>
      {hasActive && (
        <Button size="small" onClick={onReset}>
          Clear filters
        </Button>
      )}
    </div>
  );
}
